module.exports = __webpack_public_path__ + "img/message.6a30c1b1.svg";